module.exports = __webpack_public_path__ + "img/widget_photos.92c7071.svg";